export const MEMBER_DETAIL_TYPE = 'MEMBER_DETAIL_TYPE';
